<template>
    <div>
        <v-avatar v-if="!list" :color="user ? user.color : 'grey'">
            <span class="white--text headline">{{ user && user.name ? user.name[0] : '?'  }}{{ user && user.name ? user.surname[0] : '?' }}</span>
        </v-avatar>
        <v-list-tile-avatar v-if="list" :color="user ? user.color : 'grey'">
            <span class="white--text title">{{ user && user.name ? user.name[0] : '?'  }}{{ user && user.name ? user.surname[0] : '?' }}</span>
        </v-list-tile-avatar>
    </div>
</template>

<script>
export default {
  props: ['user', 'list'],
  data: () => ({})
};
</script>
